<style>
	.menus {
	  background-color: #F7F8F7;
	  width: 100%;
	  height: 15vw;
	  position: fixed;
	  bottom: 0;
	  z-index: 999999;
	  -webkit-transform: translateZ(0);
	  will-change: transform;
	}
	.menu_div {width: 25vw;height: 100%;background-color: #F7F8F7;float: left;}
	.menu_div_on{background-color: #f1f1f1;margin: 0 auto;margin-top: 2vw;
	width: 8vw;height: 8vw;border-radius: 1vw;padding: 0;overflow: hidden;}
  .menu_div_div{margin: 0 auto;margin-top: 2vw;
  width: 8vw;height: 8vw;border-radius: 1vw;padding: 0;overflow: hidden;}
  .menu_div img{width: 5vw;height: 5vw;display: block;margin: 0 auto;padding:0;overflow:hidden;margin-top: 1.5vw;}
  .menu_div img.mining{width:6vw;height: 6vw;margin-top: 1vw;}

	.menu_div span{display: block;color: #babcc5;width: 100%;height: 10vw;text-align: center;font-size:3.5vw;}
	.menu_div span.on{color: #000;}
</style>
<template>
	<div class="menus">
	    <div class="menu_div" v-for="item in list" @click="tab_change(item.url,item.id)">
	    	  <div :class="now==item.id?'menu_div_on':'menu_div_div'">
            <img :class="item.id==2?'mining':''" :src="item.img2" v-if="now==item.id">
            <img :class="item.id==2?'mining':''" :src="item.img1" v-else>
          </div>
	    	  <span class="on" v-if="now==item.id">{{item.name}}</span>
	    	  <span v-else>{{item.name}}</span>
	    </div>
	</div>
</template>
<script>

export default {

  data () {
    return {
				 list: [{id: 1, img1: '../static/images/menu/menu11.svg', img2: '../static/images/menu/menu12.svg', name: this.$t('home.index25'), url: '/'},
				       {id: 2, img1: '../static/images/menu/menu21.svg', img2: '../static/images/menu/menu22.svg', name: this.$t('home.index26'), url: '/mining'},
               {id: 3, img1: '../static/images/menu/menu31.svg', img2: '../static/images/menu/menu32.svg', name: this.$t('home.index27'), url: '/pledge'},
				       // {id: 4, img1: '../static/images/menu/menu41.svg', img2: '../static/images/menu/menu42.svg', name: 'Calculate', url: '/calculate'},
				       {id: 4, img1: '../static/images/menu/menu51.svg', img2: '../static/images/menu/menu52.svg', name: this.$t('home.index28'), url: '/my'}]
    }
  },
  props: ['now'],
  methods: {
    tab_change (url, id) {
      if (id == this.now) {
        return
      }
      this.$router.push(url)
    }
  },
  watch: {

  }
}
</script>
